import { getExampleNumber, parsePhoneNumberFromString } from 'libphonenumber-js'
import examples from 'libphonenumber-js/mobile/examples'

import type { CountryCode, PhoneNumber } from 'libphonenumber-js'

const PHONE_MASK_DIGIT = '#'

export const phoneDigits = (value: string): string => value.replace(/\D/g, '')

/** A stored `380671234567` has no `+` and parses to nothing; retry with one, and let `isValid()`
 *  keep a national-only number from matching another country. */
export const parsePhone = (value: string, country?: CountryCode): PhoneNumber | undefined => {
  const parsed = parsePhoneNumberFromString(value, country)
  if (parsed) return parsed

  const digits = phoneDigits(value)
  if (!digits) return undefined

  const international = parsePhoneNumberFromString(`+${digits}`)
  return international?.isValid() ? international : undefined
}

export const nationalPhoneExample = (code: CountryCode): string =>
  getExampleNumber(code, examples)?.formatNational() ?? ''

/** `'(201) 555-0123'` → `'(###) ###-####'` */
export const toPhoneMask = (example: string): string =>
  example.replace(/\d/g, PHONE_MASK_DIGIT)

export const applyPhoneMask = (digits: string, mask: string): string => {
  if (!mask) return digits

  let result = ''
  let index = 0

  for (const char of mask) {
    if (index >= digits.length) break

    if (char === PHONE_MASK_DIGIT) {
      result += digits[index]
      index++
    } else {
      result += char
    }
  }

  return result
}
